export const getCopyPayloadJson = (entity: { payload?: string } | undefined | null): string => {
  return entity?.payload ? JSON.stringify(JSON.parse(entity.payload), undefined, 2) : '';
};

export const getDisplayPayloadJson = (str: string) => {
  try {
    const parsedJson = JSON.parse(str);
    return JSON.stringify(parsedJson, undefined, 2);
  } catch {
    return str;
  }
};
